import { Module } from 'vuex';
import { RootState } from '../types';
import { CustomersState } from './types';
import { Customer } from '@/models/customer.model';

import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

/**
 * Default state
 */
export const state: CustomersState = {
  current: new Customer(),
  list: [],
  updates: [],
};

/**
 * Use namespaced Vuex modules
 */
const namespaced: boolean = true;

/**
 * Module export
 */
const customers: Module<CustomersState, RootState> = {
  state,
  getters,
  mutations,
  actions,
  namespaced,
};

export default customers;
